import React, { useEffect } from "react";
import WorkerRow from "./componentes/WorkerRow.tsx";
import GridLayout from "react-grid-layout";
import { v4 as uuid } from "uuid";
import moment from "moment";
import { Tooltip, Typography } from "@mui/material";
import { readPartnersByBranch } from "../../../services/partner.service.ts";
import {
  generateGradientBackground,
  generateTimeIntervals,
  generateTimeSlots,
  getBackgroundColor,
  getDateByDayOfWeek,
  isOverlapping,
  shifts,
  weekDays,
  weeks,
} from "../../../utils/constanst.js";
import { findAssistanceByDate } from "../../../services/assistanceCheck.service.ts";
import { notification } from "../../../utils/Notifications.tsx";
import { toCamelCase } from "../../../hooks/toCameCase.tsx";
import {
  findPartnerSchedule,
  readHistoryByBranchAndShiftWeekDay,
  getScheduleEditConfig,
} from "../../../services/branchSchedule.service.ts";
import { getActivePermissionByPartner } from "../../../services/permissions.service.ts";
import { getActiveHolidayByPartner } from "../../../services/holidays.service.ts";
import { getActiveIncapacityByPartner } from "../../../services/incapacities.service.ts";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/index.ts";
import {
  resetScheduleState,
  setFetchFreeDays,
  updateOrAddFreeDay,
} from "../../../store/slices/scheduleSlice.ts";
import {fetchFreeDaysByDateRangeAndPartnerIds } from "../../../services/freeDay.service.ts";
import ScheduleCompact from "./ScheduleCompact.tsx";
import { defaultFilters } from "../../../models/ColorSchedule.ts";
import ModalContainer from "../../ModalContainer.tsx";
import ModalHistorySchedule from "./ModalHistorySchedule.tsx";
import ModalConfigureFreeDays from "./componentes/ModalConfigureFreeDays.tsx";
import { isScheduleItemCoveringEssentialSlot } from "./config-horario-semanal/scheduleKeyUtils.ts";

function SheduleComponent({
  hours,
  existingsSchedules,
  formik,
  positionsArray,
  setPositionsArray,
  selectedWeek,
  selectedDay = 0,
  turno = 0,
  readOnly = false,
  highlightPosition = '',
  highlightPositionShift = '',
  markScheduleDirty,
}) {
  const { freeDays } = useSelector((state: RootState) => state.schedule);
  const dispatch = useDispatch();
  const branchId = formik.values.branchId;
  const [layout, setLayout] = React.useState<any[]>([]);  
  const [workers, setWorkers] = React.useState<any[]>([]);
  const [isScheduleEditEnabled, setIsScheduleEditEnabled] = React.useState<boolean>(true);
  const [hasCleanedInactiveSchedules, setHasCleanedInactiveSchedules] =
    React.useState(false);
  const [lastItem, setLastItem] = React.useState<any>(null);
  const [update, setUpdate] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openFreeDaysModal, setOpenFreeDaysModal] = React.useState(false);
  const [historyDay, setHistoryDay] = React.useState<any>(null);
  const [sortType, setSortType] = React.useState("Asc");
  const [sortBy, setSortBy] = React.useState("name");
  const [showSummary, setShowSummary] = React.useState(false);
  const [hoursRange, setHoursRange] = React.useState<any[]>([]);
  const [compactFilters, setCompactFilters] = React.useState({
    resumen: true,
    realTime: false,
    assistence: false,
    late: false,
    withoutAssistence: false,
    toArrive: false,
    fueraDeHorario: false,
  });
  const previousWeekKeyRef = React.useRef<string | undefined>(undefined);
  const scrollContainerRef = React.useRef<HTMLDivElement>(null);
  const positionRowRefs = React.useRef<{ [idx: number]: HTMLDivElement | null }>({});

  const getFirstPartOfTimeRange = (r) => {
    const s = String(r ?? "").trim();
    if (!s) return "";
    if (s.includes(" - ")) return (s.split(" - ")[0]?.trim().slice(0, 5) || s).slice(0, 5);
    return s.slice(0, 5);
  };
  const getLastPartOfTimeRange = (r) => {
    const s = String(r ?? "").trim();
    if (!s) return "";
    if (s.includes(" - ")) {
      const parts = s.split(" - ").map((x) => x.trim());
      return ((parts[parts.length - 1] || parts[0] || "").slice(0, 5));
    }
    return s.slice(0, 5);
  };

  React.useEffect(() => {
    if (!highlightPosition || !positionsArray || positionsArray.length === 0 || hoursRange.length === 0) return;

    const visiblePositions = positionsArray.filter((p: any) => !p.isDeleted);
    const idx = visiblePositions.findIndex((p: any) =>
      p.positionName === highlightPosition &&
      (!highlightPositionShift || p.shift === highlightPositionShift)
    );
    if (idx === -1) return;

    const rowEl = positionRowRefs.current[idx];
    const containerEl = scrollContainerRef.current;
    if (!rowEl || !containerEl) return;

    containerEl.scrollTo({ top: Math.max(0, idx * 50 - 50), behavior: 'smooth' });

    const containerAbsTop = containerEl.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: Math.max(0, containerAbsTop - 70), behavior: 'smooth' });

    rowEl.classList.add('position-pulse');
    const timer = setTimeout(() => rowEl.classList.remove('position-pulse'), 2000);
    return () => clearTimeout(timer);
  }, [highlightPosition, highlightPositionShift, hoursRange.length]);

  const getWeekRange = () => {
    if (typeof selectedWeek === 'string') {
      return selectedWeek;
    }
    return weeks[selectedWeek]?.value || '';
  };

  
  React.useEffect(() => {
    const fetchEditConfig = async () => {
      try {
        if (!branchId) return;
        const config = await getScheduleEditConfig(Number(branchId));
        setIsScheduleEditEnabled(Boolean(config?.enabled));
      } catch (error) {
        console.error("Error leyendo configuración de edición de horario:", error);
        setIsScheduleEditEnabled(true);
      }
    };

    fetchEditConfig();

    
    const intervalId = setInterval(fetchEditConfig, 60 * 1000);
    return () => clearInterval(intervalId);
  }, [branchId]);

  
  const shouldWorkOnSelectedDay = (worker: any) => {
    const diasTrabajo = (worker?.candidate as any)?.diasTrabajo;
    
    
    if (!diasTrabajo || diasTrabajo.trim() === '') {
      return true;
    }
    
    
    const workDays = diasTrabajo
      .split(',')
      .map((d: string) => parseInt(d.trim()))
      .filter((d: number) => !isNaN(d) && d >= 1 && d <= 7);
    
    
    
    
    
    
    const dayNumber = selectedDay + 1;
    
    return workDays.includes(dayNumber);
  };

  React.useEffect(() => {
    const effectiveReadOnly = readOnly || !isScheduleEditEnabled;
    if (effectiveReadOnly) return;
    if (!open) return;

    const loadHistory = async () => {
      const shiftOrder = ["Matutino", "Intermedio", "Vespertino"];

      try {
        const shiftName = shiftOrder[turno];
        const weekRange = getWeekRange();
        if (!weekRange) return;

        const history = await readHistoryByBranchAndShiftWeekDay(
          branchId,
          shiftName,
          weekRange,
          weekDays[selectedDay].name
        );
        setHistoryDay(history);
      } catch (error) {
        console.log(error);
      }
    };

    loadHistory();
  }, [selectedWeek, selectedDay, turno, open, readOnly, isScheduleEditEnabled]);

  const handleSortPositions = (type) => {
    if (type === "name") {
      setSortBy("name");
      if (sortType === "Asc") {
        setPositionsArray(
          positionsArray.sort((a, b) =>
            a.positionName.localeCompare(b.positionName)
          )
        );
        setSortType("Desc");
      } else {
        setPositionsArray(
          positionsArray.sort((a, b) =>
            b.positionName.localeCompare(a.positionName)
          )
        );
        setSortType("Asc");
      }
    } else {
      setSortBy("shift");
      if (sortType === "Asc") {
        const shiftOrder = ["Matutino", "Intermedio", "Vespertino"];
        const sorted = positionsArray.sort((a, b) => {
          const shiftComparison = shiftOrder.indexOf(a.shift) - shiftOrder.indexOf(b.shift);
          if (shiftComparison !== 0) return shiftComparison;
          
          
          const essentialComparison = (b.positionIsEssencial ? 1 : 0) - (a.positionIsEssencial ? 1 : 0);
          return essentialComparison;
        });

        setPositionsArray(sorted);
        setSortType("Desc");
      } else {
        const shiftOrder = ["Vespertino", "Intermedio", "Matutino"];
        const sorted = positionsArray.sort((a, b) => {
          const shiftComparison = shiftOrder.indexOf(a.shift) - shiftOrder.indexOf(b.shift);
          if (shiftComparison !== 0) return shiftComparison;
          
          
          const essentialComparison = (b.positionIsEssencial ? 1 : 0) - (a.positionIsEssencial ? 1 : 0);
          return essentialComparison;
        });

        setPositionsArray(sorted);
        setSortType("Asc");
      }
    }

    const newSortedLayout = layout.map((item) => {
      return {
        ...item,
        y: positionsArray.findIndex(
          (position) =>
            position.positionName === item.position &&
            position.shift === item.shift
        ),
      };
    });
    setLayout(newSortedLayout);

    setUpdate(true);
    markScheduleDirty?.();
  };

  React.useEffect(() => {
    if (existingsSchedules?.length > 0) {
      const normalizeLabel = (value: string) =>
        String(value ?? "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/\s+/g, " ")
          .trim();

      const newLayout = existingsSchedules
        .map((schedule) => {
          const schedulePosId = Number(
            schedule?.position?.id ?? schedule?.originalPositionId ?? 0,
          );
          const originalPosId = Number(schedule?.originalPositionId ?? 0);
          const scheduleShift = String(schedule?.shift ?? "").trim();
          const scheduleName = normalizeLabel(schedule?.positionName || "");

          const rowIndex = positionsArray.findIndex((position) => {
            if (!position || position.title || position.isDeleted) return false;
            if (String(position.shift ?? "").trim() !== scheduleShift) return false;

            const positionId = Number(position?.positionId ?? 0);
            const positionOriginalId = Number(position?.positionOriginalId_ ?? 0);

            if (schedulePosId > 0 && positionId === schedulePosId) return true;
            if (originalPosId > 0 && positionOriginalId === originalPosId) {
              return true;
            }

            const positionName = normalizeLabel(position?.positionName || "");
            const originalPositionName = normalizeLabel(
              position?.originalPositionName || "",
            );

            return (
              !!scheduleName &&
              (positionName === scheduleName ||
                originalPositionName === scheduleName ||
                positionName.startsWith(scheduleName + " ") ||
                originalPositionName.startsWith(scheduleName + " "))
            );
          });
          const savedRowIndex = Number(schedule?.positionY);
          const finalRowIndex =
            !Number.isNaN(savedRowIndex) &&
            savedRowIndex >= 0 &&
            positionsArray[savedRowIndex] &&
            !positionsArray[savedRowIndex]?.title &&
            !positionsArray[savedRowIndex]?.isDeleted &&
            String(positionsArray[savedRowIndex]?.shift ?? "").trim() ===
              scheduleShift
              ? savedRowIndex
              : rowIndex;

          let x = Number(schedule.positionX);
          let w = Number(schedule.positionW);
          if (
            hoursRange.length > 2 &&
            schedule.startTime != null &&
            schedule.endTime != null
          ) {
            const firstPart = getFirstPartOfTimeRange(schedule.startTime);
            const lastPart = getLastPartOfTimeRange(schedule.endTime);
            if (firstPart && lastPart) {
              const startSlotIndex = hoursRange.findIndex(
                (h) =>
                  h.display && String(h.display).startsWith(firstPart + " - "),
              );
              const endSlotIndex = hoursRange.findIndex(
                (h) =>
                  h.display && String(h.display).endsWith(" - " + lastPart),
              );
              if (startSlotIndex >= 0 && endSlotIndex >= startSlotIndex) {
                x = Math.max(0, startSlotIndex - 2);
                w = endSlotIndex - startSlotIndex + 1;
              }
            }
          }

          return {
            i: uuid(),
            originalRecordId: schedule.id,
            minH: 1,
            maxH: 1,
            minW: 1,
            show: finalRowIndex !== -1 || schedule?.id != null,
            pending: false,
            name: toCamelCase(`${schedule.partner.person.firstName || ""}`.trim()),
            position: schedule.positionName,
            originalId: schedule.partner.id,
            shift: schedule.shift,
            x,
            y: finalRowIndex,
            w,
            h: 1,
            positionId:
              schedulePosId > 0
                ? schedulePosId
                : Number(schedule?.originalPositionId ?? 0),
            positionOriginalId_:
              originalPosId > 0 ? originalPosId : schedulePosId,
            exactDate: schedule.exactDate,
            banDate: schedule.partner?.banDate,
          };
        })
        .filter((item) => item.y >= 0);

      setLayout(newLayout);
      formik.setFieldValue("schedule", newLayout);
    } else {
      setLayout([]);
      formik.setFieldValue("schedule", []);
    }
  }, [existingsSchedules, hoursRange, positionsArray]);


  React.useEffect(() => {
    setUpdate(true);
  }, [turno, selectedDay]);

  const [existingAssistances, setExistingAssistances] = React.useState<any[]>(
    []
  );

  React.useEffect(() => {
    const setHours = async () => {
      const hoursArray = await generateTimeIntervals(
        hours?.matutinoStart,
        hours?.vespertinoEnd
      );
      hoursArray.unshift(
        { key: -99, display: "Hora" },
        { key: -99, display: "Hora" }
      );

      setHoursRange(hoursArray);
    };

    setHours();
  }, [hours?.matutinoStart, hours?.vespertinoEnd]);

  React.useEffect(() => {
    if (!branchId) return;

    const fetchWorkers = async () => {
      const activeWorkers = await readPartnersByBranch(branchId, {
        active: true,
      });

      setWorkers(
        activeWorkers.map((worker) => ({
          ...worker,
          show: true,
          pending: false,
        }))
      );
    };

    fetchWorkers();
  }, [branchId]);

  React.useEffect(() => {
    const fetchDayAssistances = async () => {
      const weekRange = getWeekRange();
      if (!weekRange) return;

      const selectedDate = getDateByDayOfWeek(
        weekRange,
        weekDays[selectedDay].name
      );
      if (!selectedDate) return;

      const assistances = await findAssistanceByDate(
        moment(selectedDate).format("YYYY-MM-DD")
      );
      setExistingAssistances(assistances);
    };

    fetchDayAssistances();
  }, [selectedWeek, selectedDay]);

  
  
  
  React.useEffect(() => {
    const effectiveReadOnly = readOnly || !isScheduleEditEnabled;
    if (effectiveReadOnly) return;
    if (!layout.length) return;

    
    if (hasCleanedInactiveSchedules) return;

    
    const fetchInactiveWorkers = async () => {
      try {
        const allWorkers = await readPartnersByBranch(branchId, {});
        const inactiveWorkersMap = new Map();
        
        
        allWorkers.forEach((w) => {
          if (w.banDate && w.partnerStatus?.name === "Baja") {
            inactiveWorkersMap.set(w.id, moment(w.banDate).format("YYYY-MM-DD"));
          }
        });

        
        if (inactiveWorkersMap.size === 0) {
          setHasCleanedInactiveSchedules(true);
          return;
        }

        const filteredLayout = layout.filter((item) => {
          
          if (item?.originalId === undefined || item?.originalId === null) {
            return true;
          }

          
          const banDate = inactiveWorkersMap.get(item.originalId);
          
          
          if (!banDate) {
            return true;
          }

          
          
          let scheduleDate: string | null = null;

          if (item.exactDate) {
            
            scheduleDate = moment(item.exactDate).format("YYYY-MM-DD");
          } else {
            
            const weekRange = getWeekRange();
            if (weekRange) {
              const calculatedDate = getDateByDayOfWeek(
                weekRange,
                weekDays[selectedDay].name
              );
              if (calculatedDate) {
                scheduleDate = moment(calculatedDate).format("YYYY-MM-DD");
              }
            }
          }

          
          if (!scheduleDate) {
            return true;
          }

          
          
          const scheduleMoment = moment(scheduleDate);
          const banMoment = moment(banDate);
          
          
          
          return scheduleMoment.isBefore(banMoment, "day");
        });

        const removedCount = layout.length - filteredLayout.length;

        if (removedCount > 0) {
          setLayout(filteredLayout);
          formik.setFieldValue("schedule", filteredLayout);
          markScheduleDirty?.();

          notification(
            "Horario actualizado",
            `${removedCount} horario(s) fueron eliminados automáticamente porque el colaborador está dado de baja desde su fecha de baja en adelante.`,
            "warning"
          );
        }

        setHasCleanedInactiveSchedules(true);
      } catch (error) {
        console.error("Error al obtener información de trabajadores inactivos:", error);
        setHasCleanedInactiveSchedules(true);
      }
    };

    fetchInactiveWorkers();
  }, [layout, workers, readOnly, isScheduleEditEnabled, hasCleanedInactiveSchedules, formik, selectedWeek, selectedDay, branchId]);

  const sortWorkers = () => {
    const reorderedShifts = [
      shifts[turno],
      ...shifts.filter((_, index) => index !== turno),
    ];

    const resultArray: any = [];

    reorderedShifts.forEach((shift) => {
      const workersByShift = workers.filter(
        (worker) => 
          worker.candidate?.shift?.name === shift.name &&
          shouldWorkOnSelectedDay(worker) 
      );
      workersByShift.forEach((worker) => {
        resultArray.push(worker);
      });
    });

    setWorkers(resultArray);
  };

  useEffect(() => {
    sortWorkers();
  }, [turno]);

  const workersWithoutFreeDays = React.useMemo(() => {
    return workers.filter((worker) => {
      const hasFreeDayConfig = freeDays.some((fd) => fd.id === worker.id);
      return !hasFreeDayConfig;
    });
  }, [workers, freeDays]);

  const allWorkersHaveFreeDays = workers.length > 0 && workersWithoutFreeDays.length === 0;

  const handleDrop = async (id: string) => {
    if (!allWorkersHaveFreeDays) {
      notification(
        "Días Libres Requeridos",
        `Faltan ${workersWithoutFreeDays.length} trabajador(es) por configurar días libres. Configure todos los días libres antes de asignar trabajadores al horario.`,
        "warning"
      );
    }
    
    const workerHasFreeDays = freeDays.some((fd) => fd.id === Number(id));
    const effectiveReadOnly = readOnly || !isScheduleEditEnabled;
    if (effectiveReadOnly) {
      notification(
        "Edición deshabilitada",
        "El horario está en modo solo lectura. No se pueden asignar colaboradores.",
        "warning"
      );
      return;
    }
    const worker = workers.find((worker) => String(worker.id) === String(id));

    
    if (worker && !shouldWorkOnSelectedDay(worker)) {
      notification(
        "Día no laboral",
        `${worker.person.firstName} no trabaja en ${weekDays[selectedDay].name}.`,
        "warning"
      );
      return;
    }

    if (worker) {
      const position = positionsArray[lastItem?.y]?.positionName;
      const positionOriginalId_ =
        positionsArray[lastItem?.y]?.positionOriginalId_;
      const maxCols = hoursRange.length;
      
      const weekRange = getWeekRange();
      if (!weekRange) return;
      
      const selectedDate = getDateByDayOfWeek(
        weekRange,
        weekDays[selectedDay].name
      );
      const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
      
      try {
        console.log(`Verificando permisos para ${worker.person.firstName} en fecha ${formattedDate}`);
        const activePermission = await getActivePermissionByPartner(worker.id, formattedDate);
        
        if (activePermission) {
          console.log(`Permiso activo encontrado para ${worker.person.firstName}:`, activePermission);
          notification(
            "Permiso Activo",
            `${worker.person.firstName} tiene un permiso aprobado para el ${formattedDate}. No se puede agregar al horario.`,
            "warning"
          );
          return;
        }
      } catch (error) {
        console.error("Error verificando permisos:", error);
      }

      try {
        const activeHoliday = await getActiveHolidayByPartner(worker.id, formattedDate);
        
        if (activeHoliday) {
          console.log(`Vacaciones activas encontradas para ${worker.person.firstName}:`, activeHoliday);
          notification(
            "Vacaciones Activas",
            `${worker.person.firstName} tiene vacaciones aprobadas para el ${formattedDate}. No se puede agregar al horario.`,
            "warning"
          );
          return;
        }
      } catch (error) {
        console.error("Error verificando vacaciones:", error);
      }

      try {
        
        const adjustedDate = moment(selectedDate).add(1, 'day').format("YYYY-MM-DD");
        const activeIncapacity = await getActiveIncapacityByPartner(worker.id, adjustedDate);
        
        if (activeIncapacity) {
          console.log(`Incapacidad activa encontrada para ${worker.person.firstName}:`, activeIncapacity);
          notification(
            "Incapacidad Activa",
            `${worker.person.firstName} tiene una incapacidad aprobada para el ${formattedDate}. No se puede agregar al horario.`,
            "warning"
          );
          return;
        }
      } catch (error) {
        console.error("Error verificando incapacidades:", error);
      }
      
      if (
        Boolean(
          position === "" || position === undefined || position === null
        )
      ) {
        notification(
          "Precaución",
          "No se puede asignar a esta posición",
          "warning"
        );
        return;
      }

      const dynamicWidth = calculateDynamicWidth(lastItem.x, maxCols, 16);

      
      const exactDate = selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : null;

      const newItem = {
        i: uuid(),
        minH: 1,
        maxH: 1,
        minW: 1,
        show: false,
        pending: true,
        name: toCamelCase(
          `${worker.person.firstName || ""} ${worker.person.lastName || ""} ${worker.person.secondLastName || ""}`.trim()
        ),
        position: position,
        positionId: positionsArray[lastItem?.y]?.positionId,
        originalId: worker.id,
        shift: positionsArray[lastItem?.y]?.shift,
        positionOriginalId_,
        w: dynamicWidth, 
        exactDate: exactDate, 
        banDate: worker.banDate ? moment(worker.banDate).format("YYYY-MM-DD") : null, 
      };

      setLayout((currentLayout) => [...currentLayout, newItem]);

      setUpdate(true);
      markScheduleDirty?.();
    }
  };

  useEffect(() => {
    
    formik.setFieldValue("schedule", layout);

    
    const pendingIndex = layout.findIndex((item) => item?.pending);
    if (lastItem && pendingIndex !== -1) {
      updatePending(lastItem, pendingIndex);
      setLastItem(null);
    }
  }, [lastItem, layout]);

  useEffect(() => {
    
    if (update) {
      setLayout((currentLayout) => {
        const newLayout = currentLayout.map((record) => ({
          ...record,
          i: uuid(),
        }));
        return newLayout;
      });
      setUpdate(false); 
    }
  }, [update]);

  const validateOverflow = (x: number, w: number, maxCols: number) => {
    const endX = x + w;
    return endX <= maxCols;
  };

  const calculateDynamicWidth = (x: number, maxCols: number, defaultWidth: number = 16) => {
    const availableSpace = maxCols - x - 2; 
    return Math.min(defaultWidth, Math.max(1, availableSpace)); 
  };

  const updatePending = (oldRecord: any, pendingIndex: number) => {
    if (pendingIndex === -1 || !layout[pendingIndex]) return;

    const maxY = Number(positionsArray?.length) - 1;
    const maxCols = hoursRange.length;

    if (oldRecord.y > maxY) {
      setLayout((currentLayout) =>
        currentLayout.filter((item, index) => index !== pendingIndex)
      );
      return;
    }

    const dynamicWidth = calculateDynamicWidth(oldRecord.x, maxCols, 16);

    
    const weekRange = getWeekRange();
    const scheduleDate = weekRange ? getDateByDayOfWeek(
      weekRange,
      weekDays[selectedDay].name
    ) : null;
    const exactDate = scheduleDate ? moment(scheduleDate).format("YYYY-MM-DD") : layout[pendingIndex].exactDate;

    const updatedItem = {
      ...layout[pendingIndex],
      x: oldRecord.x,
      y: oldRecord.y,
      w: dynamicWidth,
      h: 1,
      pending: false,
      show: true,
      exactDate: exactDate, 
    };

    
    const newLayout = layout.map((item, index) =>
      index === pendingIndex ? updatedItem : item
    );

    
    const hasOverlap = isOverlapping(newLayout, updatedItem);

    if (hasOverlap) {
      
      const duplicateCount = newLayout.filter(
        (item) => item.originalId === updatedItem.originalId && item.show
      ).length;

      
      if (duplicateCount > 2) {
        updatedItem.w = 2;
      }

      const finalLayout = newLayout.map((item, index) =>
        index === pendingIndex ? updatedItem : item
      );

      setLayout(finalLayout);
    } else {
      
      setLayout((currentLayout) =>
        currentLayout.filter((item) => !item.pending)
      );
    }
  };

  const deleteItem = (id: string) => {
    const itemToDelete = layout.find((item) => item.i === id);

    if (!itemToDelete) return;

    
    const hasAssistance = existingAssistances.find(
      (assistance) => assistance.partner.id === itemToDelete.originalId
    );

    if (hasAssistance) {
      notification(
        "Precaución",
        "El trabajador tiene asistencias registradas",
        "warning"
      );
    }

    
    setLayout((currentLayout) => currentLayout.filter((item) => item.i !== id));

    
    const updatedLayout = layout.filter((item) => item.i !== id);
    formik.setFieldValue("schedule", updatedLayout);
    markScheduleDirty?.();
  };

  const handleResize = (layout_, oldItem, newItem, placeholder, e, element) => {
    const effectiveReadOnly = readOnly || !isScheduleEditEnabled;
    if (effectiveReadOnly) {
      return;
    }
    const index = layout.findIndex((item) => item?.i === oldItem?.i);

    if (index === -1) return;

    const updatedItem = {
      ...layout[index],
      w: newItem.w,
    };

    setLayout((currentLayout) =>
      currentLayout.map((item, idx) => (idx === index ? updatedItem : item))
    );
  };

  const handleResizeStop = (
    layout_,
    oldItem,
    newItem,
    placeholder,
    e,
    element
  ) => {
    if (!allWorkersHaveFreeDays) {
      notification(
        "Días Libres Requeridos",
        `Faltan ${workersWithoutFreeDays.length} trabajador(es) por configurar días libres.`,
        "warning"
      );
    }
    
    const index = layout.findIndex((item) => item?.i === oldItem?.i);
    const maxCols = hoursRange.length;

    if (index === -1) return;

    const dynamicWidth = calculateDynamicWidth(newItem.x, maxCols, newItem.w);
    
    newItem.w = dynamicWidth;

    const updatedItem = {
      ...layout[index],
      h: newItem.h,
      w: dynamicWidth, 
      y: newItem.y,
      x: newItem.x,
    };

    const tempLayout = layout.map((item, idx) =>
      idx === index ? updatedItem : item
    );

    const hasValidOverlap = isOverlapping(tempLayout, updatedItem);

    if (hasValidOverlap) {
      
      const hasAssistance = existingAssistances.find(
        (assistance) => assistance.partner.id === updatedItem.originalId
      );

      if (hasAssistance) {
        notification(
          "Precaución",
          "El trabajador tiene asistencias registradas",
          "warning"
        );
      }

      setLayout(tempLayout);
      formik.setFieldValue("schedule", tempLayout);
      markScheduleDirty?.();
    } else {
      
      const revertedItem = {
        ...updatedItem,
        h: oldItem.h,
        w: oldItem.w,
        y: oldItem.y,
        x: oldItem.x,
      };

      const revertedLayout = layout.map((item, idx) =>
        idx === index ? revertedItem : item
      );

      setLayout(revertedLayout);
    }
  };

  const onDrag = (layout_, oldItem, newItem, placeholder, e, element) => {
    const effectiveReadOnly = readOnly || !isScheduleEditEnabled;
    if (effectiveReadOnly) {
      return;
    }
    if (newItem && element) {
      if (!element.dataset.originalWidth) {
        element.dataset.originalWidth = oldItem.w.toString();
      }
      
      newItem.w = 1;
      
      newItem.x = Math.max(0, Math.min(newItem.x, hoursRange.length - 1));
    }
  };

  const onDragStop = async (layout_, oldItem, newItem, placeholder, e, element) => {
    if (!allWorkersHaveFreeDays) {
      notification(
        "Días Libres Requeridos",
        `Faltan ${workersWithoutFreeDays.length} trabajador(es) por configurar días libres.`,
        "warning"
      );
    }
    
    const effectiveReadOnly = readOnly || !isScheduleEditEnabled;
    if (effectiveReadOnly) {
      notification(
        "Edición deshabilitada",
        "El horario está en modo solo lectura. No se pueden mover los elementos.",
        "warning"
      );
      return;
    }

    const currentPosition = positionsArray[newItem.y]?.positionName;
    const positionOriginalId_ = positionsArray[newItem?.y]?.positionOriginalId_;
    const maxCols = hoursRange.length;

    
    if (!currentPosition || currentPosition === "") {
      setLayout((currentLayout) =>
        currentLayout.filter((item) => item.i !== oldItem.i)
      );

      notification(
        "Precaución",
        "No se puede asignar a esta posición",
        "warning"
      );
      return;
    }

    const worker = workers.find((worker) => String(worker.id) === String(oldItem.originalId));
    if (worker) {
      const weekRange = getWeekRange();
      if (!weekRange) return;
      
      const selectedDate = getDateByDayOfWeek(
        weekRange,
        weekDays[selectedDay].name
      );
      const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
      
      try {
        console.log(`Verificando permisos para ${worker.person.firstName} en fecha ${formattedDate} (onDragStop)`);
        const activePermission = await getActivePermissionByPartner(worker.id, formattedDate);
        
        if (activePermission) {
          console.log(`Permiso activo encontrado para ${worker.person.firstName} (onDragStop):`, activePermission);
          notification(
            "Permiso Activo",
            `${worker.person.firstName} tiene un permiso aprobado para el ${formattedDate}. No se puede mover en el horario.`,
            "warning"
          );
          return;
        }
      } catch (error) {
        console.error("Error verificando permisos:", error);
      }

      try {
        const activeHoliday = await getActiveHolidayByPartner(worker.id, formattedDate);
        
        if (activeHoliday) {
          console.log(`Vacaciones activas encontradas para ${worker.person.firstName} (onDragStop):`, activeHoliday);
          notification(
            "Vacaciones Activas",
            `${worker.person.firstName} tiene vacaciones aprobadas para el ${formattedDate}. No se puede mover en el horario.`,
            "warning"
          );
          return;
        }
      } catch (error) {
        console.error("Error verificando vacaciones:", error);
      }

      try {
        
        const adjustedDate = moment(selectedDate).add(1, 'day').format("YYYY-MM-DD");
        const activeIncapacity = await getActiveIncapacityByPartner(worker.id, adjustedDate);
        
        if (activeIncapacity) {
          console.log(`Incapacidad activa encontrada para ${worker.person.firstName} (onDragStop):`, activeIncapacity);
          notification(
            "Incapacidad Activa",
            `${worker.person.firstName} tiene una incapacidad aprobada para el ${formattedDate}. No se puede mover en el horario.`,
            "warning"
          );
          return;
        }
      } catch (error) {
        console.error("Error verificando incapacidades:", error);
      }
    }

    const originalWidth = element?.dataset?.originalWidth ? parseInt(element.dataset.originalWidth) : oldItem.w;
    const dynamicWidth = calculateDynamicWidth(newItem.x, maxCols, originalWidth);
    
    const finalWidth = dynamicWidth < originalWidth ? dynamicWidth : originalWidth;
    newItem.w = finalWidth;
    
    if (finalWidth < originalWidth) {
      notification(
        "Aviso",
        "Se reajustó el ancho del elemento para evitar desbordamiento",
        "warning"
      );
    }
    
    if (element?.dataset?.originalWidth) {
      delete element.dataset.originalWidth;
    }

    const index = layout.findIndex((item) => item.i === oldItem.i);
    if (index === -1) return;

    
    const weekRange = getWeekRange();
    const selectedDate = weekRange ? getDateByDayOfWeek(
      weekRange,
      weekDays[selectedDay].name
    ) : null;
    const exactDate = selectedDate ? moment(selectedDate).format("YYYY-MM-DD") : layout[index].exactDate;

    const updatedItem = {
      ...layout[index],
      x: newItem.x,
      y: newItem.y,
      h: newItem.h,
      w: finalWidth,
      position: currentPosition,
      shift: positionsArray[newItem.y]?.shift,
      positionOriginalId_: positionOriginalId_,
      exactDate: exactDate, 
    };

    const updatedLayout = layout.map((item, idx) =>
      idx === index ? updatedItem : item
    );

    const hasValidOverlap = isOverlapping(updatedLayout, updatedItem);

    if (hasValidOverlap) {
      
      const hasAssistance = existingAssistances.find(
        (assistance) => assistance.partner.id === updatedItem.originalId
      );

      if (hasAssistance) {
        notification(
          "Precaución",
          "El trabajador tiene asistencias registradas",
          "warning"
        );
      }

      setLayout(updatedLayout);
      formik.setFieldValue("schedule", updatedLayout);
      markScheduleDirty?.();
    } else {
      
      notification(
        "Aviso",
        "No se puede colocar en esa posición debido a conflictos",
        "warning"
      );
    }
  };

  const autocompleteLayout = async () => {
    const effectiveReadOnly = readOnly || !isScheduleEditEnabled;
    if (effectiveReadOnly) {
      notification(
        "Edición deshabilitada",
        "El horario está en modo solo lectura. No se puede autocompletar.",
        "warning"
      );
      return;
    }
    if (!allWorkersHaveFreeDays) {
      notification(
        "Días Libres Requeridos",
        `Faltan ${workersWithoutFreeDays.length} trabajador(es) por configurar días libres.`,
        "warning"
      );
    }
    
    try {
      setLayout([]);
      const hoursRanges = generateTimeSlots(hours);

      const availablePositions =
        turno !== 3
          ? positionsArray.filter(
              (position) => position.shift === shifts[turno].name
            )
          : positionsArray;

      const availableWorkers =
        turno !== 3
          ? workers.filter(
              (worker) => 
                worker.candidate?.shift?.name === shifts[turno].name &&
                shouldWorkOnSelectedDay(worker) 
            )
          : workers.filter((worker) => shouldWorkOnSelectedDay(worker)); 

      const processedWorkers = new Set();
      const newLayout: any[] = [];

      
      for (const position of availablePositions) {
        const workersByPosition = availableWorkers.filter(
          (worker) =>
            worker.candidate?.vacancy?.position?.name ===
              position.originalPositionName &&
            worker.candidate?.shift?.name === position.shift &&
            !processedWorkers.has(worker.id)
        );

        if (workersByPosition.length === 0) continue;

        const worker = workersByPosition[0];

        
        const freeDayRecord = freeDays.find(
          (record) => record.id === worker.id
        );
        if (freeDayRecord?.freeDays.includes(selectedDay)) {
          processedWorkers.add(worker.id);
          continue;
        }

        try {
          const weekRange = getWeekRange();
          if (!weekRange) continue;
          
          const selectedDate = getDateByDayOfWeek(
            weekRange,
            weekDays[selectedDay].name
          );
          const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
          
          const adjustedDate = moment(selectedDate).add(1, 'day').format("YYYY-MM-DD");
          const activeIncapacity = await getActiveIncapacityByPartner(worker.id, adjustedDate);
          if (activeIncapacity) {
            console.log(`Incapacidad activa encontrada para ${worker.person.firstName} en autocompletado:`, activeIncapacity);
            processedWorkers.add(worker.id);
            continue;
          }
        } catch (error) {
          console.error("Error verificando incapacidades en autocompletado:", error);
        }

        processedWorkers.add(worker.id);

        try {
          const partnerSchedules = await findPartnerSchedule(
            worker.id,
            `dayOfWeek=${selectedDay}`
          );

          const baseItem = {
            i: uuid(),
            minH: 1,
            maxH: 1,
            minW: 1,
            show: true,
            pending: false,
            name: toCamelCase(
              `${worker.person.firstName || ""} ${worker.person.lastName || ""} ${worker.person.secondLastName || ""}`.trim()
            ),
            position: position.positionName,
            originalId: worker.id,
            h: 1,
            positionId: position.positionId,
            shift: position.shift,
            positionOriginalId_: Number(position?.positionOriginalId_),
          };

          if (partnerSchedules.length > 0) {
            partnerSchedules.forEach((schedule) => {
              const firstPart = getFirstPartOfTimeRange(schedule.startTime);
              const lastPart = getLastPartOfTimeRange(schedule.endTime);
              const startSlotIndex = hoursRange.findIndex(
                (hour) => hour.display && String(hour.display).startsWith(firstPart + " - ")
              );
              const endSlotIndex = hoursRange.findIndex(
                (hour) => hour.display && String(hour.display).endsWith(" - " + lastPart)
              );
              const startIndex = startSlotIndex >= 0 ? startSlotIndex - 2 : -1;
              const endIndex = endSlotIndex >= 0 ? endSlotIndex : -1;

              if (startIndex >= 0 && endSlotIndex >= startSlotIndex) {
                const y = positionsArray.findIndex(
                  (positionA) =>
                    positionA.positionName === position.positionName &&
                    positionA.shift === position.shift
                );

                const calculatedWidth = endSlotIndex - startSlotIndex + 1;
                const dynamicWidth = calculateDynamicWidth(startIndex, hoursRanges.length, calculatedWidth);

                newLayout.push({
                  ...baseItem,
                  i: uuid(), 
                  x: startIndex,
                  y,
                  w: dynamicWidth,
                });
              }
            });
          } else {
            
            const { shiftIndex, width } = calculateShiftDefaults(
              position.shift,
              hoursRanges
            );
            const y = positionsArray.findIndex(
              (positionA) =>
                positionA.positionName === position.positionName &&
                positionA.shift === position.shift
            );

            if (y >= 0 && width > 0) {
              const dynamicWidth = calculateDynamicWidth(shiftIndex, hoursRanges.length, width);
              
              newLayout.push({
                ...baseItem,
                x: shiftIndex,
                y,
                w: dynamicWidth,
                shift: worker.candidate?.shift?.name || position.shift,
              });
            }
          }
        } catch (error) {
          console.error(`Error processing worker ${worker.id}:`, error);
        }
      }

      setLayout(newLayout);
      formik.setFieldValue("schedule", newLayout);
      markScheduleDirty?.();
    } catch (error) {
      console.error("Error in autocompleteLayout:", error);
      notification(
        "Error",
        "Hubo un problema al autocompletar el horario",
        "danger"
      );
    }
  };

  
  const calculateShiftDefaults = (shift: string, hoursRanges: any[]) => {
    let shiftIndex = 0;
    let width = 0;

    switch (shift) {
      case "Matutino":
        shiftIndex = 0;
        width = hoursRanges[0]?.ranges?.length || 0;
        break;
      case "Intermedio":
        shiftIndex =
          hoursRanges[0]?.ranges?.findIndex(
            (range) => range.display === hoursRanges[1]?.ranges?.[0]?.display
          ) || 0;
        width = hoursRanges[1]?.ranges?.length || 0;
        break;
      case "Vespertino":
        const intermedioStart =
          hoursRanges[0]?.ranges?.findIndex(
            (range) => range.display === hoursRanges[1]?.ranges?.[0]?.display
          ) || 0;
        const vespertinoStart =
          hoursRanges[1]?.ranges?.findIndex(
            (range) => range.display === hoursRanges[2]?.ranges?.[0]?.display
          ) || 0;
        shiftIndex = intermedioStart + vespertinoStart;
        width = hoursRanges[2]?.ranges?.length || 0;
        break;
      default:
        shiftIndex = 0;
        width = 0;
    }

    return { shiftIndex, width };
  };

  const [filter, setFilter] = React.useState("");
  const [selectedFilter, setSelectedFilter] = React.useState("SA");

  const generateSummary = () => {
    setShowSummary(!showSummary);
  };

  const handleViewHistory = (records: any[]) => {
    const newLayout = records.map((record) => ({
      i: uuid(),
      minH: 1,
      maxH: 1,
      minW: 1,
      show: true,
      pending: false,
      name: toCamelCase(
        `${record.partner.person.firstName || ""} ${record.partner.person.lastName || ""} ${record.partner.person.secondLastName || ""}`.trim()
      ),
      position: record.positionName,
      originalId: record.partner.id,
      x: Number(record.positionX),
      y: Number(record.positionY) || 0,
      w: Number(record.positionW),
      h: 1,
      positionId: record.position.id,
      shift: record.shift,
      positionOriginalId_: Number(record?.originalPositionId),
    }));
    setLayout(newLayout);
    markScheduleDirty?.();
  };

  React.useEffect(() => {
    const loadFreeDaysForAllWorkers = async () => {
      const weekRange = getWeekRange();
      if (!weekRange || workers.length === 0) return;
      
      try {
        const currentWeekKey = typeof selectedWeek === 'string' ? selectedWeek : selectedWeek?.toString();
        
        if (previousWeekKeyRef.current !== currentWeekKey) {
          dispatch(resetScheduleState());
          previousWeekKeyRef.current = currentWeekKey;
        }
        const partnerIds = workers.map(worker => worker.id);
        const freeDaysData = await fetchFreeDaysByDateRangeAndPartnerIds(weekRange, partnerIds);
        const loadedFreeDays = freeDaysData
          .map((freeDay) => {
            if (freeDay?.days && Array.isArray(freeDay.days) && freeDay.days.length > 0) {
              const selectedDays = freeDay.days.map((day) => {
                const index = weekDays.findIndex((d) => d.name === day);
                return index !== -1 ? index : null;
              }).filter(index => index !== null);
              
              if (selectedDays.length > 0) {
                return {
                  id: freeDay.partner.id,
                  freeDays: selectedDays,
                };
              }
            }
            return null;
          })
          .filter(fd => fd !== null);
        
        loadedFreeDays.forEach(freeDay => {
          dispatch(updateOrAddFreeDay(freeDay));
        });
        
        dispatch(setFetchFreeDays());
      } catch (error) {
        console.error("Error loading free days:", error);
        dispatch(setFetchFreeDays());
      }
    };
    
    loadFreeDaysForAllWorkers();
  }, [selectedWeek, workers.length]);

  if (!hoursRange.length) return;

  
  const isEssentialPositionCovered = (position) => {
    // Solo verificar si es esencial Y se muestra en el horario
    if (!position?.positionIsEssencial || position?.title) return false;
    if (position?.positionShowSchedule === false) return false;
    if (!formik.values.schedule || formik.values.schedule.length === 0) return false;

    return formik.values.schedule.some((scheduleItem) =>
      isScheduleItemCoveringEssentialSlot(scheduleItem, position),
    );
  };

  const filteredWorkers = workers
    .filter((worker) => worker.show)
    .filter((worker) => shouldWorkOnSelectedDay(worker)) 
    .filter(
      (worker) =>
        worker.person.firstName.toLowerCase().includes(filter.toLowerCase()) ||
        worker.person.lastName.toLowerCase().includes(filter.toLowerCase()) ||
        worker.person.secondLastName
          .toLowerCase()
          .includes(filter.toLowerCase()) ||
        worker.person.curp.toLowerCase().includes(filter.toLowerCase()) ||
        worker.candidate?.vacancy?.position?.name
          .toLowerCase()
          .includes(filter.toLowerCase())
    )
    .filter((worker) => !worker.candidate?.vacancy?.isDeleted)
    .filter((worker) => {
      if (selectedFilter === "DL") {
        const freeDayRecord = freeDays.find((f) => f.id === worker.id);
        return freeDayRecord && freeDayRecord.freeDays.includes(selectedDay);
      }
      if (selectedFilter === "CA")
        return (
          layout.filter(
            (item) =>
              item?.originalId === worker.id && item?.show && !item?.pending
          ).length >= 1
        );
      if (selectedFilter === "SA")
        return (
          layout.filter(
            (item) =>
              item?.originalId === worker.id && item?.show && !item?.pending
          ).length === 0 &&
          !freeDays
            .find((f) => f.id === worker.id)
            ?.freeDays.includes(selectedDay)
        );
      return true;
    })
    .sort(
      (a, b) =>
        a.candidate?.vacancy?.position?.order -
        b.candidate?.vacancy?.position?.order
    );


  return (
    <React.Fragment>
      <style>
        {`
          .custom-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .custom-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          @keyframes positionPulse {
            0%   { outline: 2px solid transparent; box-shadow: 0 0 0 0 rgba(30,144,255,0); }
            25%  { outline: 2px solid #1E90FF; box-shadow: 0 0 0 6px rgba(30,144,255,0.45); }
            75%  { outline: 2px solid #1E90FF; box-shadow: 0 0 0 3px rgba(30,144,255,0.2); }
            100% { outline: 2px solid transparent; box-shadow: 0 0 0 0 rgba(30,144,255,0); }
          }
          .position-pulse {
            animation: positionPulse 0.9s ease-in-out 2;
          }
        `}
      </style>
      <div className="position-relative mb-4" style={{ width: "100%" }}>
        {!readOnly && (
          <div
            style={{
              position: "absolute",
              top: 0,
              right: "15px",
              display: "flex",
              gap: "8px",
              zIndex: 10,
            }}
          >
            <button
              className={`btn position-relative ${
                allWorkersHaveFreeDays
                  ? "btn-success"
                  : "btn-warning"
              }`}
              onClick={() => {
                setOpenFreeDaysModal(true);
              }}
              title={
                allWorkersHaveFreeDays
                  ? "Todos los trabajadores tienen días libres configurados"
                  : `${workersWithoutFreeDays.length} trabajador(es) sin días libres`
              }
              style={{
                paddingRight: !allWorkersHaveFreeDays ? "2.5rem" : "0.75rem",
                paddingLeft: "0.75rem",
                fontWeight: 500,
                borderRadius: "6px",
                border: "none",
                boxShadow: allWorkersHaveFreeDays 
                  ? "0 2px 4px rgba(40, 167, 69, 0.2)" 
                  : "0 2px 4px rgba(255, 193, 7, 0.2)",
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = allWorkersHaveFreeDays
                  ? "0 4px 8px rgba(40, 167, 69, 0.3)"
                  : "0 4px 8px rgba(255, 193, 7, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = allWorkersHaveFreeDays
                  ? "0 2px 4px rgba(40, 167, 69, 0.2)"
                  : "0 2px 4px rgba(255, 193, 7, 0.2)";
              }}
            >
              <i className={`fa-solid ${
                allWorkersHaveFreeDays
                  ? "fa-check-circle"
                  : "fa-exclamation-triangle"
              } me-2`}></i>
              Días Libres
              {!allWorkersHaveFreeDays && (
                <span 
                  className="badge position-absolute"
                  style={{
                    backgroundColor: "#dc3545",
                    color: "white",
                    borderRadius: "50%",
                    width: "22px",
                    height: "22px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: 600,
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    padding: 0,
                    lineHeight: 1,
                    boxShadow: "0 2px 4px rgba(220, 53, 69, 0.3)",
                  }}
                >
                  {workersWithoutFreeDays.length}
                </span>
              )}
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setOpen(true);
              }}
              style={{
                fontWeight: 500,
                borderRadius: "6px",
                border: "none",
                boxShadow: "0 2px 4px rgba(108, 117, 125, 0.2)",
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = "0 4px 8px rgba(108, 117, 125, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 4px rgba(108, 117, 125, 0.2)";
              }}
            >
              <i className="fa-solid fa-clock-rotate-left me-2"></i>
              Historial
            </button>
          </div>
        )}
        
        <div className="row fs-13px align-middle">
          <div className="d-flex align-items-center fs-13px col-md-3">
          <button
            className={`btn btn-white me-2 ${
              selectedFilter === "DL" ? "bg-blue text-white" : ""
            }`}
            onClick={() => setSelectedFilter("DL")}
          >
            Días Libres
          </button>
          <button
            className={`btn btn-white me-2 ${
              selectedFilter === "CA" ? "bg-blue text-white" : ""
            }`}
            onClick={() => setSelectedFilter("CA")}
          >
            Asignados
          </button>
          <button
            className={`btn btn-white ${
              selectedFilter === "SA" ? "bg-blue text-white" : ""
            }`}
            onClick={() => setSelectedFilter("SA")}
          >
            Sin Asignar
          </button>
        </div>

        {!readOnly && (
          <div className="d-flex align-items-center col-md-8 ">
            <div className="col-md-9" role="group">
              <button
                className="btn btn-secondary ms-2"
                onClick={() => {
                  generateSummary();
                  setCompactFilters({ ...defaultFilters, resumen: true });
                }}
              >
                {showSummary ? "Vista detallada" : "Vista compacta"}
              </button>
              {showSummary && (
                <React.Fragment>
                  <button
                    className="btn btn-azul ms-2"
                    onClick={() =>
                      setCompactFilters({ ...defaultFilters, resumen: true })
                    }
                    style={{
                      ...(!compactFilters.resumen && {
                        opacity: 0.5,
                      }),
                    }}
                  >
                    Resumen
                  </button>

                  <button
                    className="btn btn-azul ms-2"
                    onClick={() =>
                      setCompactFilters({ ...defaultFilters, realTime: true })
                    }
                    style={{
                      ...(!compactFilters.realTime && {
                        opacity: 0.5,
                      }),
                    }}
                  >
                    Tiempo real
                  </button>

                  <button
                    className="btn btn-azul ms-2"
                    onClick={() =>
                      setCompactFilters({ ...defaultFilters, assistence: true })
                    }
                    style={{
                      ...(!compactFilters.assistence && {
                        opacity: 0.5,
                      }),
                    }}
                  >
                    Asistencias
                  </button>

                  <button
                    className="btn btn-azul ms-2"
                    onClick={() =>
                      setCompactFilters({ ...defaultFilters, late: true })
                    }
                    style={{
                      ...(!compactFilters.late && {
                        opacity: 0.5,
                      }),
                    }}
                  >
                    Retardo
                  </button>

                  <button
                    className="btn btn-azul ms-2"
                    onClick={() =>
                      setCompactFilters({ ...defaultFilters, toArrive: true })
                    }
                    style={{
                      ...(!compactFilters.toArrive && {
                        opacity: 0.5,
                      }),
                    }}
                  >
                    Proximos a llegar
                  </button>

                  <button
                    className="btn btn-azul ms-2"
                    onClick={() =>
                      setCompactFilters({
                        ...defaultFilters,
                        withoutAssistence: true,
                      })
                    }
                    style={{
                      ...(!compactFilters.withoutAssistence && {
                        opacity: 0.5,
                      }),
                    }}
                  >
                    Sin asistencia
                  </button>

                  <button
                    className="btn btn-azul ms-2"
                    onClick={() =>
                      setCompactFilters({
                        ...defaultFilters,
                        fueraDeHorario: true,
                      })
                    }
                    style={{
                      ...(!compactFilters.fueraDeHorario && {
                        opacity: 0.5,
                      }),
                    }}
                  >
                    Fuera de horario
                  </button>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
        </div>
      </div>

      <div
        className="row d-flex justify-content-between"
        style={{
          flex: 1,
          flexDirection: "row",
          borderRadius: "0.25rem",
          overflow: "hidden",
          border: "1px solid #AFAFAF55",
        }}
      >
        <div
          className="col-2 py-2"
          style={{
            backgroundColor: "#F0F0F0",
            maxHeight: 800,
            opacity: readOnly ? 0.8 : 1,
          }}
        >
          <h4 className="mb-2">Trabajadores</h4>
          {!readOnly && (
            <input
              type="text"
              className="form-control mb-2"
              placeholder="Buscar trabajador"
              onChange={(e) => setFilter(e.target.value)}
              style={{
                borderRadius: "0.25rem",
              }}
            />
          )}
          <div
            className="custom-scrollbar"
            style={{
              overflowY: "auto",
              maxHeight: "700px",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {filteredWorkers.map((worker) => (
              <WorkerRow
                partner={worker}
                originalId={worker.id}
                name={toCamelCase(
                  `${worker.person.firstName || ""} ${worker.person.lastName || ""} ${worker.person.secondLastName || ""}`.trim()
                )}
                position={worker.candidate?.vacancy?.position?.name}
                week={selectedWeek}
                selectedDay={selectedDay}
                freeDay={
                  worker.candidate.freeDay === weekDays[selectedDay].name
                }
                shift={worker.candidate?.shift?.name}
                key={worker.id}
                handleDrop={readOnly ? undefined : (id: string) => handleDrop(id)}
                curp={worker.person.curp}
                count={
                  layout.filter(
                    (item) =>
                      item?.originalId === worker.id &&
                      item?.show &&
                      !item?.pending
                  ).length
                }
                readOnly={readOnly}
              />
            ))}
          </div>
        </div>

        <div
          ref={scrollContainerRef}
          className="col-10 custom-scrollbar"
          style={{
            paddingBlock: "10px",
            boxShadow: "4px 6px 6px rgba(0, 0, 0, 0.1)",
            overflowY: "auto",
            overflowX: "auto",
            position: "relative",
            maxHeight: 800,
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <div
            style={{
              position: "sticky",
              top: -10,
              zIndex: 5,
              backgroundColor: "white",
            }}
          >
            <GridLayout
              className="layout"
              layout={Array.from({ length: hoursRange.length }, (_, i) => ({
                i: i.toString(),
                x: i,
                y: 0,
                w: 1,
                h: 1,
                static: true,
              }))}
              cols={hoursRange.length}
              rowHeight={40}
              width={2400}
              margin={[0, 0]}
              compactType={null}
            >
              {hoursRange.map((hour, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    textAlign: "center",
                    borderRight: index !== 0 ? "2px solid #EEE" : "none",
                    borderBottom: "2px solid #EEE",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: 600,
                    fontSize: "10px",
                    backgroundColor: "white",
                  }}
                >
                  {index === 0 && turno !== 3 && !readOnly && (
                    <React.Fragment>
                      <a
                        href="#/"
                        onClick={() => handleSortPositions("name")}
                        className="fw-600 me-3"
                      >
                        Nombre
                        <i
                          className={`fa-solid ${
                            sortBy === "name" &&
                            (sortType === "Asc"
                              ? "fa-sort-up"
                              : "fa-sort-down")
                          } ms-1`}
                        ></i>
                      </a>
                    </React.Fragment>
                  )}
                  {index > 1 && hour.display}
                </div>
              ))}
            </GridLayout>
          </div>
          {!readOnly && showSummary ? (
            <ScheduleCompact
              hours={hours}
              existingsSchedules={existingsSchedules}
              formik={formik}
              positionsArray={positionsArray}
              setPositionsArray={setPositionsArray}
              selectedWeek={selectedWeek}
              selectedDay={selectedDay}
              turno={turno}
              hoursRange={hoursRange}
              deleteItem={deleteItem}
              handleResize={handleResize}
              handleResizeStop={handleResizeStop}
              layout={layout}
              onDrag={onDrag}
              onDragStop={onDragStop}
              setLastItem={setLastItem}
              compactFilters={compactFilters}
              updateLine={() => {}}
            />
          ) : (
            <div className="d-flex flex-row" style={{ width: 2400 }}>
              <div
                style={{
                  position: "sticky",
                  left: -10,
                  zIndex: 6,
                  backgroundColor: "white",
                }}
              >
                {positionsArray
                  .filter((position) => !position.isDeleted)
                  .map((key, index) => {
                    return (
                      <div
                        key={index}
                        ref={(el) => { positionRowRefs.current[index] = el; }}
                        data-grid={{
                          x: 0,
                          y: index,
                          w: key?.title ? 36 : 2,
                          h: 1,
                          static: true,
                        }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          fontSize: "10px",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "left",
                          borderRight: "2px solid #EEE",
                          borderBottom: `${
                            key?.title ? "3px" : "2px"
                          } solid #EEE`,
                          borderTop: `${key?.title ? "3px solid" : ""} ${
                            key?.title === "Matutino"
                              ? "#FFD700"
                              : key.title === "Vespertino"
                              ? "#FF6347"
                              : "#4682B4"
                          }`,
                          paddingInline: "5px",
                          fontWeight: 600,
                          height: 50,
                          borderLeft: `3px solid ${
                            !key?.shifts
                              ? key.shift === "Matutino"
                                ? "#FFD700"
                                : key.shift === "Vespertino"
                                ? "#FF6347"
                                : "#4682B4"
                              : "#4682B4"
                          }`,
                          backgroundColor: isEssentialPositionCovered(key) 
                            ? "#28a745" 
                            : key?.positionIsEssencial && !key?.title 
                            ? "#FFF9E6" 
                            : "transparent",
                          width: (2400 / hoursRange?.length) * 2,
                        }}
                      >
                        {key.title && (
                          <p className="w-100 mt-3 fs-15px fw-800 bg">
                            {key?.title ?? key.positionName}
                          </p>
                        )}
                        <Tooltip title={key?.shifts?.join(", ") ?? ""}>
                          <p 
                            className="w-100 mt-auto"
                            style={{
                              fontWeight: (isEssentialPositionCovered(key) || (key?.positionIsEssencial && !key?.title)) ? "bold" : "normal",
                              color: isEssentialPositionCovered(key) ? "#ffffff" : "inherit"
                            }}
                          >
                            {key?.positionName}
                          </p>
                        </Tooltip>
                      </div>
                    );
                  })}
              </div>

              <GridLayout
                className="layout"
                layout={readOnly || !isScheduleEditEnabled ? layout.map(item => ({ ...item, static: true })) : layout}
                cols={hoursRange.length}
                maxRows={positionsArray?.length}
                rowHeight={50}
                width={2400}
                preventCollision={false}
                allowOverlap={true}
                isResizable={!readOnly && isScheduleEditEnabled}
                isDraggable={!readOnly && isScheduleEditEnabled}
                isDroppable={!readOnly && isScheduleEditEnabled}
                onResize={readOnly || !isScheduleEditEnabled ? undefined : handleResize}
                onResizeStop={readOnly || !isScheduleEditEnabled ? undefined : handleResizeStop}
                onDrag={readOnly || !isScheduleEditEnabled ? undefined : onDrag}
                onDragStop={readOnly || !isScheduleEditEnabled ? undefined : onDragStop}
                compactType={null}
                margin={[0, 0]}
                style={{
                  background: generateGradientBackground(
                    hoursRange,
                    hours,
                    turno
                  ),
                  width: `${2400}px`,
                  position: "relative",
                }}
                onDrop={readOnly || !isScheduleEditEnabled ? undefined : (layoutx, layoutItem, _event) => {
                  setLastItem(layoutItem);
                }}
              >
                {positionsArray
                  .filter((position) => !position.isDeleted)
                  .map((key, index) => {
                    return (
                      <div
                        key={index}
                        data-grid={{
                          x: 0,
                          y: index,
                          w: key?.title ? 36 : 2,
                          h: 1,
                          static: true,
                        }}
                        style={{
                          fontSize: "10px",
                          display: "none",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "left",
                          borderRight: "2px solid #EEE",
                          borderBottom: `${
                            key?.title ? "3px" : "2px"
                          } solid #EEE`,
                          borderTop: `${key?.title ? "3px solid" : ""} ${
                            key?.title === "Matutino"
                              ? "#FFD700"
                              : key.title === "Vespertino"
                              ? "#FF6347"
                              : "#4682B4"
                          }`,
                          paddingInline: "5px",
                          fontWeight: 600,
                          borderLeft: `3px solid ${
                            key.shift === "Matutino"
                              ? "#FFD700"
                              : key.shift === "Vespertino"
                              ? "#FF6347"
                              : "#4682B4"
                          }`,
                          backgroundColor: isEssentialPositionCovered(key) 
                            ? "#28a745" 
                            : key?.positionIsEssencial && !key?.title 
                            ? "#FFF9E6" 
                            : "white",
                          position: "sticky",
                          left: 0,
                          zIndex: 3,
                        }}
                      >
                        {key.title && (
                          <p className="w-100 mt-3 fs-15px fw-800 bg">
                            {key?.title ?? key.positionName}
                          </p>
                        )}
                        <p 
                          className="w-100 mt-auto"
                          style={{
                            fontWeight: (isEssentialPositionCovered(key) || (key?.positionIsEssencial && !key?.title)) ? "bold" : "normal",
                            color: isEssentialPositionCovered(key) ? "#ffffff" : "inherit"
                          }}
                        >
                          {key.positionName}
                        </p>
                      </div>
                    );
                  })}

                {layout.map((item, index) => {
                  if (item?.x === undefined || !item?.show) return null;
                  return (
                    <div
                      key={item?.i}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: readOnly ? "default" : "move",
                      }}
                      data-grid={{ x: item?.x, y: item?.y, w: item?.w, h: 1, static: readOnly }}
                    >
                      <div
                        style={{
                          paddingLeft: "8px",
                          width: "100%",
                          borderRadius: "5px",
                          paddingBlock: "4px",
                          ...getBackgroundColor(item, index, positionsArray),
                        }}
                        className="shadow-sm"
                      >
                        <Tooltip
                          title={`${item.name} | ${item.position} | ${
                            item.w / 2
                          } hrs`}
                          arrow
                        >
                          <div className="d-flex flex-row">
                            {!readOnly && isScheduleEditEnabled && (
                              <div
                                onMouseDown={(e) => e.stopPropagation()}
                                className="position-absolute m-2"
                                style={{
                                  left: 0,
                                  top: "35%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                }}
                                onClick={() => deleteItem(item?.i)}
                              >
                                <i className="fa-solid fa-xmark"></i>
                              </div>
                            )}
                            <Typography fontWeight={500} marginLeft={1.5}>
                              {item?.name}
                            </Typography>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  );
                })}
              </GridLayout>
            </div>
          )}
        </div>

        {!readOnly && isScheduleEditEnabled && (
          <div className="w-100 pt-4 pb-2 d-flex justify-content-between align-items-center">
            {!allWorkersHaveFreeDays && workers.length > 0 && (
              <div className="alert alert-warning mb-0 py-2 px-3 d-flex align-items-center" role="alert">
                <i className="fa-solid fa-triangle-exclamation me-2"></i>
                <span className="fs-13px">
                  <strong>{workersWithoutFreeDays.length}</strong> trabajador(es) sin día libre configurado. 
                  {workersWithoutFreeDays.length <= 5 && (
                    <span className="ms-1">
                      ({workersWithoutFreeDays.map(w => w.person.firstName).join(', ')})
                    </span>
                  )}
                </span>
              </div>
            )}
            <button
              className={`btn ms-auto ${allWorkersHaveFreeDays ? 'btn-primary' : 'btn-secondary'}`}
              onClick={autocompleteLayout}
              disabled={!allWorkersHaveFreeDays}
            >
              Autocompletar
            </button>
          </div>
        )}
      </div>

      {!readOnly && (
        <>
          <ModalContainer
            open={open}
            title="Historial de cambios"
            closeFn={() => setOpen(false)}
            children={
              <ModalHistorySchedule
                historyData={historyDay}
                onView={handleViewHistory}
                onClose={() => setOpen(false)}
              />
            }
          />
          <ModalContainer
            open={openFreeDaysModal}
            title="Configurar Días Libres"
            size="xl"
            closeFn={() => setOpenFreeDaysModal(false)}
            children={
              <ModalConfigureFreeDays
                workers={workers}
                weekSelected={selectedWeek}
                onClose={() => {
                  setOpenFreeDaysModal(false);
                  dispatch(setFetchFreeDays());
                }}
              />
            }
          />
        </>
      )}
    </React.Fragment>
  );
}

export default SheduleComponent;
